import { render, staticRenderFns } from "./ShortLink.vue?vue&type=template&id=2828ab81&scoped=true"
import script from "./ShortLink.vue?vue&type=script&lang=ts"
export * from "./ShortLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2828ab81",
  null
  
)

export default component.exports